import { render } from "./TechnicalSupport.vue?vue&type=template&id=1e750abf"
import script from "./TechnicalSupport.vue?vue&type=script&lang=js"
export * from "./TechnicalSupport.vue?vue&type=script&lang=js"

import "./TechnicalSupport.vue?vue&type=style&index=0&id=1e750abf&lang=css"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__